import { Component } from "vue-property-decorator";
import BaseBlock from "@/blocks/base-block";
import { Block } from '../../../helpers/components';
import Bowser from "bowser";
import { RegistrationMailRequestDTO } from "../../../model/RegistrationMailRequestDTO";
import { htmlEncode } from '../../../helpers/html'
import { getRecaptchaToken } from '../../../helpers/recaptcha'

interface FormValues {
	name: string;
	email: string;
	agreement: boolean;
}

@Block() @Component
export class HomepageRegistrationForm extends BaseBlock {
	formValues: FormValues = {
		name: "",
		email: "",
		agreement: false
	};
	odeslanoOk: boolean = false;
	odeslanoKo: boolean = false;
	logo = this.getText('form-registration-image');
	nadpis = this.getText('form-registration-title');
	podnadpis = this.getText('form-registration-subtitle');

	async send() {
		var validationErros = this.getValidationErrors()
		const bowser = Bowser.parse(window.navigator.userAgent)

		if (validationErros.length > 0) {
			alert(validationErros.join('\n'));
		}
		else {
			try {
 
				const message = "" + htmlEncode(this.formValues.name) + "," + htmlEncode(this.formValues.email) + "," + this.formValues.agreement + "";
				const gdprInformation = "" + this.$store.timeId + "," + this.$store.langId + "," + bowser.browser.name + "," + bowser.browser.version + "," + bowser.os.name + "," + bowser.os.version + "";
				const mailBody: any[] = [message];
				const mailRequest: RegistrationMailRequestDTO = {
					mailTo: this.getText('mail-to'),
					mailToClient: this.formValues.email,
					message: this.getText('mail-template', mailBody),
					messageToClient: this.getText('mail-client-template', mailBody),
					senderName: this.getText('sender-name'),
					senderEmail: this.getText('sender-email'),
					gdprInformation: gdprInformation,
					subject: this.getText('subject'),
					recaptchaResponse: await getRecaptchaToken('registration_form')
				};

				await this.$mailService.sendRegistrationFormMail(mailRequest);


				this.odeslanoOk = true;
			}
			catch (error) {
				this.odeslanoKo = true;
			}
		}
	}

	getValidationErrors(): string[] {
		var result = [];
		if (!this.formValues.email) {
			result.push(this.getText('validation-email'))
		}
		else if (!this.validEmail(this.formValues.email)) {
			result.push(this.getText('validation-email-invalid'))
		}
		if (!this.formValues.agreement) {
			result.push(this.getText('validation-agreement'))
		}
		return result;
	}

	validEmail(email: string) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
}

export default HomepageRegistrationForm;
